/**
 * Doc comments are hard-wrapped at ~100 columns. Split one into blocks to render
 * as flowing paragraphs: a paragraph whose continuation lines are indented and
 * look like code (an example) stays code, everything else is one paragraph.
 */
export type DocBlock = { kind: 'p'; text: string } | { kind: 'code'; text: string }

export function docBlocks(text: string): DocBlock[] {
  return text.split(/\n\s*\n/).filter((p) => p.trim()).map((para) => {
    const lines = para.split('\n')
    const isCode = lines.length > 1
      && lines.slice(1).some((l) => /^\s{2,}\S/.test(l))
      && lines.every((l) => !l.trim() || /^\s{2,}/.test(l) || /[=(){};]/.test(l))
    return isCode
      ? { kind: 'code' as const, text: para.replace(/^\n+|\n+$/g, '') }
      : { kind: 'p' as const, text: lines.map((l) => l.trim()).join(' ') }
  })
}

/** A paragraph's runs: plain text and `inline code` (JSDoc `{@link x}` included). */
export function inlineRuns(text: string): Array<{ code: boolean; text: string }> {
  // JSDoc `{@link name}` / `{@link name | label}` reads as the name, in code font.
  text = text.replace(/\{@link\s+([^}|\s]+)[^}]*\}/g, '`$1`')
  return text.split(/(`[^`]+`)/g).filter(Boolean).map((part) =>
    part.length > 1 && part.startsWith('`') && part.endsWith('`')
      ? { code: true, text: part.slice(1, -1) }
      : { code: false, text: part })
}
